import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { margin } from '@mui/system'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACES.m,
  },
  connectionText: {
    display: 'flex',
    flexDirection: 'column',
  },
  connectionSubtitle: {
    fontSize: FONTS.SIZES.s,
  },
  image: {
    '&&': {
      display: 'block',

      borderRadius: 5,
      objectFit: 'cover',

      width: '90px',
      height: '90px',
      fill: theme.palette.custom.darkBlue2,
      margin: '0 auto',
    },
  },
  linkWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACES.xxs,
    minHeight: 30,

    '& > svg': {
      color: theme.palette.custom.primary,
    },
  },
  linkTitle: {
    minWidth: 60,
  },
  linkText: {
    '&&': {
      maxWidth: 140,

      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  linkIcon: {
    '&&': {
      color: theme.palette.custom.grey2,

      width: 20,
      height: 'auto',
    },
  },
}))
